/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './graphql.schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type AvailableWallDecorScenesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AvailableWallDecorScenesQuery = {
  getAvailableWallDecorScenes: Array<{
    labs: Array<string | null> | null;
    wallDecorSceneForDisplayId: string | null;
    pieces: Array<{
      height: number | null;
      width: number | null;
      y: number | null;
      x: number | null;
      flip: boolean | null;
      WallDecorPieceForDisplayId: string | null;
      imageHeight: number | null;
      imageWidth: number | null;
      wallDecorConfigId: string;
      type: Types.WallDecorPieceForDisplayType | null;
    } | null> | null;
  } | null> | null;
};

export type GetAvailableWallDecorConfigsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAvailableWallDecorConfigsQuery = {
  getAvailableWallDecorConfigs: Array<{
    wallDecorConfigId: string | null;
    config: string | null;
  } | null> | null;
};

export type WallDecorProductFragment = {
  availableOnOccasion: Array<Types.SessionOccasion | null> | null;
  composedImages: string | null;
  config: string | null;
  configurationImages: string | null;
  deliveryTime: number | null;
  hasWizard: boolean | null;
  imagesRequired: boolean | null;
  name: string | null;
  productId: string | null;
  showDeliveryTime: boolean | null;
  status: boolean | null;
  type: Types.ProductType | null;
  sortOrder: number | null;
  organizationId: string | null;
  tags: Array<string | null> | null;
  description: Array<{
    language: string | null;
    text: string | null;
  } | null> | null;
  price: Array<{ code: string | null; price: number | null } | null> | null;
  requiredImages: { max: number | null; min: number | null } | null;
};

export type GetWallDecorsLookBookConfigForPrivateSessionQueryVariables = Exact<{
  privateSessionId: string;
}>;

export type GetWallDecorsLookBookConfigForPrivateSessionQuery = {
  getWallDecorsLookBookConfigForPrivateSession: {
    labsInPlay: Array<string | null> | null;
    labProducts: Array<{
      availableOnOccasion: Array<Types.SessionOccasion | null> | null;
      composedImages: string | null;
      config: string | null;
      configurationImages: string | null;
      deliveryTime: number | null;
      hasWizard: boolean | null;
      imagesRequired: boolean | null;
      name: string | null;
      productId: string | null;
      showDeliveryTime: boolean | null;
      status: boolean | null;
      type: Types.ProductType | null;
      sortOrder: number | null;
      organizationId: string | null;
      tags: Array<string | null> | null;
      description: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
      requiredImages: { max: number | null; min: number | null } | null;
    } | null> | null;
    zalamoStandaloneWallDecor: {
      availableOnOccasion: Array<Types.SessionOccasion | null> | null;
      composedImages: string | null;
      config: string | null;
      configurationImages: string | null;
      deliveryTime: number | null;
      hasWizard: boolean | null;
      imagesRequired: boolean | null;
      name: string | null;
      productId: string | null;
      showDeliveryTime: boolean | null;
      status: boolean | null;
      type: Types.ProductType | null;
      sortOrder: number | null;
      organizationId: string | null;
      tags: Array<string | null> | null;
      description: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
      requiredImages: { max: number | null; min: number | null } | null;
    } | null;
    zalamoStandaloneTambour: {
      availableOnOccasion: Array<Types.SessionOccasion | null> | null;
      composedImages: string | null;
      config: string | null;
      configurationImages: string | null;
      deliveryTime: number | null;
      hasWizard: boolean | null;
      imagesRequired: boolean | null;
      name: string | null;
      productId: string | null;
      showDeliveryTime: boolean | null;
      status: boolean | null;
      type: Types.ProductType | null;
      sortOrder: number | null;
      organizationId: string | null;
      tags: Array<string | null> | null;
      description: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
      requiredImages: { max: number | null; min: number | null } | null;
    } | null;
  } | null;
};

export type GetWallDecorsLookBookConfigForPublicSessionQueryVariables = Exact<{
  publicSessionId: string;
}>;

export type GetWallDecorsLookBookConfigForPublicSessionQuery = {
  getWallDecorLookBookConfigForPublicSession: {
    labsInPlay: Array<string | null> | null;
    labProducts: Array<{
      availableOnOccasion: Array<Types.SessionOccasion | null> | null;
      composedImages: string | null;
      config: string | null;
      configurationImages: string | null;
      deliveryTime: number | null;
      hasWizard: boolean | null;
      imagesRequired: boolean | null;
      name: string | null;
      productId: string | null;
      showDeliveryTime: boolean | null;
      status: boolean | null;
      type: Types.ProductType | null;
      sortOrder: number | null;
      organizationId: string | null;
      tags: Array<string | null> | null;
      description: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
      requiredImages: { max: number | null; min: number | null } | null;
    } | null> | null;
    zalamoStandaloneWallDecor: {
      availableOnOccasion: Array<Types.SessionOccasion | null> | null;
      composedImages: string | null;
      config: string | null;
      configurationImages: string | null;
      deliveryTime: number | null;
      hasWizard: boolean | null;
      imagesRequired: boolean | null;
      name: string | null;
      productId: string | null;
      showDeliveryTime: boolean | null;
      status: boolean | null;
      type: Types.ProductType | null;
      sortOrder: number | null;
      organizationId: string | null;
      tags: Array<string | null> | null;
      description: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
      requiredImages: { max: number | null; min: number | null } | null;
    } | null;
    zalamoStandaloneTambour: {
      availableOnOccasion: Array<Types.SessionOccasion | null> | null;
      composedImages: string | null;
      config: string | null;
      configurationImages: string | null;
      deliveryTime: number | null;
      hasWizard: boolean | null;
      imagesRequired: boolean | null;
      name: string | null;
      productId: string | null;
      showDeliveryTime: boolean | null;
      status: boolean | null;
      type: Types.ProductType | null;
      sortOrder: number | null;
      organizationId: string | null;
      tags: Array<string | null> | null;
      description: Array<{
        language: string | null;
        text: string | null;
      } | null> | null;
      price: Array<{ code: string | null; price: number | null } | null> | null;
      requiredImages: { max: number | null; min: number | null } | null;
    } | null;
  } | null;
};

export const WallDecorProductFragmentDoc = gql`
  fragment WallDecorProduct on Product {
    availableOnOccasion
    composedImages
    config
    configurationImages
    deliveryTime
    description {
      language
      text
    }
    hasWizard
    imagesRequired
    name
    price {
      code
      price
    }
    productId
    requiredImages {
      max
      min
    }
    showDeliveryTime
    status
    type
    sortOrder
    organizationId
    tags
  }
`;
export const AvailableWallDecorScenesDocument = gql`
  query availableWallDecorScenes {
    getAvailableWallDecorScenes {
      pieces {
        height
        width
        y
        x
        flip
        WallDecorPieceForDisplayId
        imageHeight
        imageWidth
        wallDecorConfigId
        type
      }
      labs
      wallDecorSceneForDisplayId
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class AvailableWallDecorScenesGQL extends Apollo.Query<
  AvailableWallDecorScenesQuery,
  AvailableWallDecorScenesQueryVariables
> {
  document = AvailableWallDecorScenesDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetAvailableWallDecorConfigsDocument = gql`
  query getAvailableWallDecorConfigs {
    getAvailableWallDecorConfigs {
      wallDecorConfigId
      config
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class GetAvailableWallDecorConfigsGQL extends Apollo.Query<
  GetAvailableWallDecorConfigsQuery,
  GetAvailableWallDecorConfigsQueryVariables
> {
  document = GetAvailableWallDecorConfigsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetWallDecorsLookBookConfigForPrivateSessionDocument = gql`
  query getWallDecorsLookBookConfigForPrivateSession($privateSessionId: ID!) {
    getWallDecorsLookBookConfigForPrivateSession(
      privateSessionId: $privateSessionId
    ) {
      labProducts {
        ...WallDecorProduct
      }
      zalamoStandaloneWallDecor {
        ...WallDecorProduct
      }
      zalamoStandaloneTambour {
        ...WallDecorProduct
      }
      labsInPlay
    }
  }
  ${WallDecorProductFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetWallDecorsLookBookConfigForPrivateSessionGQL extends Apollo.Query<
  GetWallDecorsLookBookConfigForPrivateSessionQuery,
  GetWallDecorsLookBookConfigForPrivateSessionQueryVariables
> {
  document = GetWallDecorsLookBookConfigForPrivateSessionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
export const GetWallDecorsLookBookConfigForPublicSessionDocument = gql`
  query getWallDecorsLookBookConfigForPublicSession($publicSessionId: ID!) {
    getWallDecorLookBookConfigForPublicSession(
      publicSessionId: $publicSessionId
    ) {
      labProducts {
        ...WallDecorProduct
      }
      zalamoStandaloneWallDecor {
        ...WallDecorProduct
      }
      zalamoStandaloneTambour {
        ...WallDecorProduct
      }
      labsInPlay
    }
  }
  ${WallDecorProductFragmentDoc}
`;

@Injectable({
  providedIn: 'root',
})
export class GetWallDecorsLookBookConfigForPublicSessionGQL extends Apollo.Query<
  GetWallDecorsLookBookConfigForPublicSessionQuery,
  GetWallDecorsLookBookConfigForPublicSessionQueryVariables
> {
  document = GetWallDecorsLookBookConfigForPublicSessionDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
